"use client";

import { Input } from "antd";
import { useState } from "react";
import { useBlog } from "../(main)/(with-footer)/blog/components/BlogContext";
import { loadFunc } from "../(main)/(with-footer)/blog/common";

const Search = Input.Search;


export const SearchInput = (props: any) => {
    const [loading, setLoading] = useState(false);

    const {
        setHasNext,
        setNextUrl,
        setBlogPosts,
        setCount,
        setSearch,
        checkedTags,
      } = useBlog();

    const onSearch = async (value: string, event :any) => {
        event.preventDefault();

        setLoading(true);
        setNextUrl('');
        // TODO: may be have a global logic to handle resetting on search, reset on input search and on Tree search
        setHasNext(true);
        setBlogPosts([]);
        setNextUrl("");
        setSearch(value);

        loadFunc(
            true,
            undefined,
            value,
            checkedTags,
            [],
            setBlogPosts,
            setHasNext,
            setNextUrl,
            setCount,
          );
        setLoading(false);
    };
    
    return (
        <Search 
            size="large" 
            placeholder="Search by aspiring career expertise"
            allowClear
            loading={loading}
            onSearch={onSearch}
        />
    )
};